import { render, staticRenderFns } from "./courseAchievement.vue?vue&type=template&id=40c439c6&scoped=true&"
import script from "./courseAchievement.vue?vue&type=script&lang=js&"
export * from "./courseAchievement.vue?vue&type=script&lang=js&"
import style0 from "./courseAchievement.vue?vue&type=style&index=0&id=40c439c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c439c6",
  null
  
)

export default component.exports